/**
 * Stable per-install device id for this browser.
 *
 * Persisted in localStorage so it survives reloads/logouts (but not a cache
 * clear or a different browser — which is exactly the granularity we want:
 * "this browser install"). Advertised on the Phoenix socket (presence meta) AND
 * sent with the FCM token, so push fan-out can skip the device the user is
 * currently connected on while still notifying their other, offline devices.
 */
const KEY = 'inmeet_device_id'

function newId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) return crypto.randomUUID()
  return 'dev-' + Math.random().toString(36).slice(2) + Date.now().toString(36)
}

export function getDeviceId(): string {
  try {
    let id = localStorage.getItem(KEY)
    if (!id) {
      id = newId()
      localStorage.setItem(KEY, id)
    }
    return id
  } catch {
    // Private mode / storage disabled — fall back to a volatile id (push still
    // works; the online-device skip just won't correlate for this session).
    return newId()
  }
}
